import IsLoading from "@/components/layouts/IsLoading";
import SetLinks from "@/components/layouts/SetLinks";
import Show from "@/components/layouts/Show";
import SourceDataFindingsEdit from "@/components/lists/findings/SourceDataFindingsEdit";
import CoordinatingGroupContext from "@/contexts/data/CoordinatingGroupContext";
import InstitutionContext from "@/contexts/data/InstitutionContext";
import MasterGroupContext from "@/contexts/data/MasterGroupContext";
import ParticipantContext from "@/contexts/data/ParticipantContext";
import TrialContext from "@/contexts/data/TrialContext";
import { SourceDataFindingsInstitutionCreateLink, SourceDataFindingsParticipantCreateLink, SourceDataFindingsTrialCreateLink } from "@/contexts/layouts/LinkContext";
import useParticipantSourceDataFindings from "@/hooks/data/useParticipantSourceDataFindings";
import { Typography } from "@mui/material";
import { FC, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";

const ParticipantSourceDataFindingsEdit: FC = () => {
    const { data: trial } = useContext(TrialContext);
    const { data: masterGroup } = useContext(MasterGroupContext);
    const { data: coordinatingGroup } = useContext(CoordinatingGroupContext);
    const { data: institution } = useContext(InstitutionContext);
    const { data: participant } = useContext(ParticipantContext);
    const { data: sourceDataFindings, loading: sourceDataFindingsLoading, validating: sourceDataFindingsValidating } = useParticipantSourceDataFindings(participant?.id, { revalidateOnFocus: false });


    const { sourceDataFindingId } = useParams();

    const sourceDataFinding = useMemo(() => {
        return sourceDataFindings?.find(x => x.id === sourceDataFindingId as any)
    }, [sourceDataFindings, sourceDataFindingId])

    const loading = sourceDataFindingsLoading;
    const validating = sourceDataFindingsValidating;

    return (
        <>
            <SetLinks 
                createTrialLink={SourceDataFindingsTrialCreateLink} 
                createInstitutionLink={SourceDataFindingsInstitutionCreateLink} 
                createParticipantLink={SourceDataFindingsParticipantCreateLink}  
            />
            <IsLoading name="participant-findings-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                Findings
                </Typography>
                <SourceDataFindingsEdit
                    sourceDataFinding={sourceDataFinding}
                />
            </Show>
        </>
    )
};

export default ParticipantSourceDataFindingsEdit;